import useArchive from "@hooks/useArchive"
import GalleryPhoto from "../components/GalleryPhoto"

export default function useGalleryArchive(photos?: General.Resources.AcceptanceGallery[]) {
    const archive = useArchive(photos)

    archive.useEmpty({
        heading: "No photos here",
        description: "Salon doesn't have acceptances right now."
    })

    archive.useGrid({
        columns: "4",
        gap: "m"
    })

    archive.usePagination(40, "acceptances")

    archive.useComponent(GalleryPhoto)

    return archive
}